import * as React from 'react';
export const bofiSvg = React.forwardRef(function bofiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#1B4475',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M10.38 6.05h13.49c.7 0 1.21.48 1.21 1.1v5.82c-3.11-4.24-14.7-6.92-14.7-6.92zm-4.33-2.6s.88 2.87 3.7 4.2C12.57 9 17.5 9.52 20.5 11.2c1.58.67 2.29 2.52 2.29 2.52s1.23.5 1.93 1.17c.7.68 1.24 1.85 1.24 3.87 0 2.01-1.59 4.03-3.35 5.2-1.76 1.18-3.87 2.86-7.22 2.86-1.4 0-4.75-.5-4.57-2.18.17-1.68 4.57-4.54 6.16-5.71-3.7.67-8.63 4.7-8.63 4.7-1.05-.34-2.11-2.52-2.11-2.52s4.75-1.18 5.8-3.86c-1.58 1.34-5.98 1.5-5.98 1.5v-2.68s2.64 0 4.4-1.51c-2.28.17-4.4-.34-4.4-.34V11.2s1.24.33 2.64-.17C7.46 10.85 6.05 9.5 6.05 9.5V3.46zM21.27 14s-.17-1.12-1.38-1.76c-1.21-.64-4.15-1.12-4.15-1.12l-5.36-1.6c0 1.27 2.42 2.72 2.42 2.72s-2.08 0-2.42.16c.52 1.28 3.63 1.76 3.63 1.76s-2.42.96-2.77 1.28c1.56.96 3.98.64 3.98.64s-1.73 1.44-1.9 2.08c.52-.16 4.32-1.44 7.08-1.44 2.77 0 3.8 1.12 3.8 1.12s.18-1.76-1.03-2.56-3.8-.48-5.19-.96c-1.38-.48-1.38-1.44-1.38-1.44s2.77 1.28 4.67 1.12z',
      }),
    ),
  );
});
bofiSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bofi = {
  category: 'brand',
  colorable: false,
  name: 'bofi',
  svg: bofiSvg,
};
